module.exports = __webpack_public_path__ + "static/media/forPets.d2cdff44.jpg";